/**
 * ⟦A-141 §3 · C17⟧ Le fond de l'écran-titre : *« une vidéo qui tourne de ce qu'est le jeu »*,
 * sans vidéo, `image-rendering: pixelated` conservé (`.pixel-asset`). Zéro fichier neuf.
 *
 * ⟦C55 · A-172⟧ **Une seule chambre, `chambre-n1`.** Le fond faisait défiler en fondu lent les 10
 * planches de chambre (cinq niveaux × jour/nuit), donc les anciennes `chambre-n2..n5`, d'un
 * autre style que la chambre de jeu : l'écran-titre montrait des pièces que la partie ne montre
 * plus jamais (la chambre reste `chambre-n1` tout le jeu, `niveauChambre`). Il ne montre plus que
 * le fond de n1 SANS genre (`fondChambreN1(null)`, le même fichier que `sceneChambre(1, …)` pour
 * le jour comme pour la nuit : n1 n'a qu'une planche), sans ses calques : sous un recadrage
 * `cover` animé, les superposer à l'emprise demanderait un calcul qui n'a pas sa place dans un
 * simple fond. Les `chambre-n2..n5-*.png` restent sur le disque (jamais supprimer un asset).
 *
 * Il n'y a donc plus de fondu enchaîné à orchestrer : un seul `<img>` qui apparaît puis « respire »
 * (`menu-apparition` + `menu-respire`, `app.css`), en aller-retour pour ne jamais claquer au
 * bouclage (le fondu d'avant retombait à zéro à chaque cycle, ce qui, avec une seule planche, aurait
 * fait clignoter l'écran).
 *
 * ⚠️ **Coupé par `prefers-reduced-motion`** : voir `.ecran-titre-image` dans `app.css` (la règle
 * globale `animation-duration: 0.001ms` ne suffit pas pour une boucle infinie, elle la ferait
 * clignoter). Une règle dédiée fige la planche, immobile.
 */

import { fondChambreN1 } from "../../game/chambre";

export function FondMenu() {
  return (
    <div className="ecran-titre-fond" aria-hidden="true">
      <img src={fondChambreN1(null)} alt="" className="ecran-titre-image pixel-asset" />
    </div>
  );
}
